const ReadOnlyMetadataItem = ({
  keyName,
  value,
}: {
  keyName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}) =>
  keyName !== "markdown_enabled" &&
  keyName !== "streaming_enabled" && (
    <div className="mb-1">
      <span className="font-semibold">{keyName}:</span>{" "}
      {typeof value === "object" ? JSON.stringify(value) : value}
    </div>
  );

export default ReadOnlyMetadataItem;
